<template>
  <div class="index">
    <div class="content">
      <div class="about">
        <div class="about-left">
          <img
            src="../../assets/image/about.png"
            alt=""
          >
        </div>
        <div class="about-right">
          <div class="text">
            金骊科技聚焦于金融科技服务领域，是一家以信息技术服务为主导，为企业提供信用解决方案的金融科技公司。是国内领先的“互联网+政务+金融”服务平台， 目前已上线17省，30余家地市交易中心及国企招采平台，为政府部门、金融机构、市场主体等提供综合金融科技服务解决方案。同时为金融机构提供业务线上化处理解决方案，助力机构业务全数字化升级。金骊科技研发了国内第一家数据安全运营平台，拥有专业团队为客户建设数据安全体系，为客户数据产权、流通交易、收益分配、安全治理提供数据安全解决方案。
          </div>
          <!-- <div class="text">
            深圳金骊科技发展有限公司（以下简称金骊保）成立于2007年11月，注册资本金50亿元，系经省国资委批准成立的国有融资性担保公司。
          </div>
          <div class="text">
            公司由2家股东组成，四川能投金鼎产融控股集团有限公司（其实际控制人为四川省能源投资集团有限责任公司）占股60%，中国农发重点建设基金有限公司（其实际控制人为中国农业发展银行）占股40%。
          </div>
          <div class="text">
            金骊保是全国农发系统首个注资融资担保机构的试点单位，中国融资担保业协会理事单位，四川省融资担保业协会副会长单位，中国银行间市场交易商协会会员单位。目前公司已获得2家主流评级机构给予的“AAA”主体信用评级，担保业务能力、风险管控能力、创新发展能力等经营核心能力获得了公开市场的充分肯定，标志着公司正式迈入担保行业“第一梯队”。
          </div>
          <div class="text">
            公司自成立以来，始终秉承“安全、规范、稳健、高效”的经营理念，严格遵循担保行业的运行规则，紧密结合市场需求，以国家产业政策为导向，以信用担保为纽带，以风险防范为重点，致力为水电、能源及上下游、中小企业提供以融资担保为主的多元化综合性金融服务，已逐步发展成为四川省具有较强实力的专业融资担保平台。
          </div> -->
          <!-- <a-button
            type="link"
            @click="$router.push('./brandintroduction')"
          >
            查看更多
          </a-button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.index{
    display: flex;
    flex-direction: column;
    height: 780px;
    background-color: #f2f2f2;
}
.content {
  width: 1200px;
  height: 700px;
  margin: 0 auto;
  background: #ffff;
  margin-top: 50px;
}
.about {
    display: flex;
    justify-content: center;
    padding-top: 60px;
    .about-left {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
      }
    }
    .about-right {
      position: relative;
      .text {
        text-align:justify;
        margin-left: 100px;
        width: 670px;
        text-indent: 2em;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666;
        line-height: 36px;
      }
      ::v-deep .ant-btn {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 96px;
        height: 40px;
        border: 1px solid #ddd;
        border-radius: 20px;
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999;
        background-color: #fff;
        cursor: pointer;
        transition: all 0.5s;
      }
    }
  }
</style>
